import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "src/app/shared/http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { AreaContactDto } from "../models/AreaContactDto";

@Injectable()
export class AreaContactService {
  constructor(private readonly httpService: HttpService) {}

  getAreaContacts(): Observable<AreaContactDto[]> {
    return this.httpService.get(APIEndpoints.getAreaContactList);
  }

  changeAreaContact(data: AreaContactDto) {
    return this.httpService.post(APIEndpoints.changeAreaContact, data, false);
  }

  deleteAreaContact(data: AreaContactDto) {
    return this.httpService.post(APIEndpoints.deleteAreaContact, data, false);
  }
}
